import QuadShape from '../../../plugins/quadshape';
export default QuadShape;